import { RawSource, Source } from '../../../shared/interfaces/source';
import { SourceTypeFactory } from '../../SelectSourceType/factories/sourceTypesFactory';
import { SOURCE_STATUS_DATA_MAP } from '../../constants/source-status';
import { EntityMetaFactory } from '../../../shared/factory/entityMetaFactory';
import { EntityActionsFactory } from '../../../entity-actions/factory/entityActionsFactory';
import { SOURCE_ACTIONS_DISPLAY_DETAILS } from '../../SourceActions/constant/source-actions';

export function SourceListFactory(rawSources: RawSource[], sort = true): Source[] {
  if (!rawSources) {
    return [];
  }

  const sources = rawSources.map(SourceFactory);

  if (!sort) {
    return sources;
  }

  return sources.sort((s1, s2) => s2.id - s1.id);
}

export function SourceFactory(rawSource: RawSource): Source {
  return {
    id: rawSource.id,
    seqId: rawSource.seq_id,
    name: rawSource.name,
    sourceType: { ...SourceTypeFactory(rawSource.source_type) },
    status: {
      ...SOURCE_STATUS_DATA_MAP[rawSource.status.type],
      helperText: rawSource.status.hover_text || undefined
    },
    actions: EntityActionsFactory(rawSource.source_actions ?? [], SOURCE_ACTIONS_DISPLAY_DETAILS),
    integrationsCount: rawSource.integrations_count || 0,
    ...EntityMetaFactory({
      created_ts: rawSource.created_ts,
      created_by: rawSource.created_by,
      updated_by: rawSource.updated_by,
      updated_ts: rawSource.updated_ts
    })
  };
}
